export default __webpack_public_path__ + "static/media/long_banner.b9729b16.jpeg";